
import React from "react";
import Home from "./Pages/Home"
import "./styles.css";



function App() {
  return (
    <>
      <Home/>
    </>
  );
}

export default App;
